import React from "react";
import { muv } from "./data/muv";
// import VehicleCard from "./VehicleCard";
import VehicleFullCard from "./VehicleFullCard";

export default function Muv() {
  return (

<>



<section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>MUV Cars </h1>
          </div>
        </div>
      </section>

    {/* <div className="vehicle-page">

      <div className="grid">
        {muv.map((v) => (
          <VehicleCard key={v.id} v={v} />
        ))}
      </div>
    </div> */}/

<div className="vehicle-page">
  <div className="vehicle-container">
    {muv.map((v) => (
      <VehicleFullCard key={v.id} v={v} />
    ))}
  </div>
</div>

</>
  );
}
